import { LeadAssignee } from "../../../../types/types";

export interface Region {
  id: string;
  locations: {
    alpha_2: string;
    country: string;
    state?: string;
    subdivision_code?: string;
  }[];
  is_global: boolean;
  custom_region: string;
  lead_assignee: LeadAssignee;
  lead_subscribers: LeadAssignee[];
}

export const getRegionsLocation = <T extends "country" | "state">(
  locations: Region["locations"],
  location_type: T
): T extends "country"
  ? { alpha_2: string; country: string }[]
  : { subdivision_code: string; state: string }[] => {
  return locations.map(({ state, subdivision_code, ...rest }) =>
    location_type === "country"
      ? rest
      : { subdivision_code: subdivision_code ?? "", state: state ?? "" }
  ) as any;
};

export interface RegionMultiSelectFieldRef {
  clearChips: () => void;
}
